export var ValidationCode;
(function (ValidationCode) {
    ValidationCode["EMAIL_INVALID"] = "EMAIL_INVALID";
    ValidationCode["PASSWORD_REQUIRED"] = "PASSWORD_REQUIRED";
    ValidationCode["PASSWORD_TOO_SHORT"] = "PASSWORD_TOO_SHORT";
    ValidationCode["CURRENT_PASSWORD_REQUIRED"] = "CURRENT_PASSWORD_REQUIRED";
    ValidationCode["FULL_NAME_REQUIRED"] = "FULL_NAME_REQUIRED";
    ValidationCode["VERIFICATION_TOKEN_MISSING"] = "VERIFICATION_TOKEN_MISSING";
    ValidationCode["RESET_TOKEN_MISSING"] = "RESET_TOKEN_MISSING";
    ValidationCode["EVAL_ACTION_DUPLICATE"] = "EVAL_ACTION_DUPLICATE";
    ValidationCode["EVAL_GPIO_PIN_DUPLICATE"] = "EVAL_GPIO_PIN_DUPLICATE";
    ValidationCode["EVAL_ALERT_WITH_WARNING"] = "EVAL_ALERT_WITH_WARNING";
    ValidationCode["EVAL_EDGE_AXIS_MISMATCH"] = "EVAL_EDGE_AXIS_MISMATCH";
})(ValidationCode || (ValidationCode = {}));
const validationCodes = new Set(Object.values(ValidationCode));
export const isValidationCode = (value) => typeof value === "string" && validationCodes.has(value);
//# sourceMappingURL=validation-code.js.map